<div class="backdrop" *ngIf="loading()">
  <div class="spinner">
    <mat-icon class="rotate">sync</mat-icon>
  </div>
</div>